<template>
  <div id="LoginCard" class="card rounded">
    <div class="section">
      <div class="card-image">
        <img
          src="@/assets/web_icons/beyond_logo.png"
          alt="Wealth Navi Icon"
          style="max-width: 180px;"
        />
      </div>
      <div class="card-content" style="padding-top: 0.5em;">
        <div class="content">
          <p class="title" style="color: black;">
            WEALTH NAVI
          </p>
          <p class="subtitle is-6" style="color: #717171;">
            - Welcome -
          </p>
          <section>
            <b-field label="Username" label-position="inside">
              <b-input
                icon="account-key-outline"
                placeholder="Financial Advisor"
                v-model.lazy="username"
              />
            </b-field>

            <b-field label="Password" label-position="inside">
              <b-input
                type="password"
                icon="lock-outline"
                placeholder="******"
                v-model.lazy="password"
                @keyup.native.enter="validateLoginForm"
              />
            </b-field>
            <b-button
              type="is-primary"
              icon-left="login"
              expanded
              @click.prevent="validateLoginForm"
            >
              Login
            </b-button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import UserApi from "@/services/UserApi";
import TokenManager from "@/utils/TokenManager";
import AlertManager from "@/utils/AlertManager";

export default {
  name: "LoginCard",
  data() {
    return {
      username: null,
      password: null
    };
  },
  methods: {
    ...mapMutations({
      setUserProfile: "SET_USER_PROFILE"
    }),
    validateLoginForm: function() {
      if (
        this.username &&
        this.username !== "" &&
        this.password &&
        this.password !== ""
      ) {
        this.performLogin();
      }
    },
    performLogin: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const params = {
        username: this.username,
        password: this.password
      };
      const response = await UserApi.requestSignIn(params);
      loadingComponent.close();

      if (response.status) {
        TokenManager.setUserToken(response.payload.token);
        this.getCurrentUserProfile(response.payload.user.id);
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    },
    getCurrentUserProfile: async function(user_id) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await UserApi.requestUserInfoById(user_id);
      loadingComponent.close();
      if (response.status) {
        this.setUserProfile(response.payload);
        this.$router.push({ name: "dashboard" });
      } else {
        TokenManager.clearUserToken();
        AlertManager.showErrorSnackbar(response.message);
      }
    }
  }
};
</script>

<style scoped>
.rounded {
  border-radius: 12px;
}

.content p:not(:last-child) {
  margin-bottom: 1.5rem;
}
</style>
